import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ScreenLayoutProvider } from './ScreenLayoutProvider';
import { Sidebar } from './Sidebar';
import { useScreenSidebar } from './useSidebar';
import useMobile from '../hooks/useMobile';
import { Main, Section } from './styled';
/**
 * Layout component that provides a screen with an optional contextual sidebar, header and main content area.
 * Takes a optional id prop to make the sidebar state unique.
 */
export function Root(props) {
    const { topbar, content, sidebar, id } = props;
    const { set } = useScreenSidebar(id);
    const location = useLocation();
    const isMobile = useMobile();
    useEffect(() => {
        if (isMobile) {
            set(false);
        }
    }, [isMobile, location, set]);
    return (<ScreenLayoutProvider id={id}>
      <Section>
        {topbar}

        <Main>
          {content}
          {sidebar && <Sidebar id={id}>{sidebar}</Sidebar>}
        </Main>
      </Section>
    </ScreenLayoutProvider>);
}
